export default {
  de: {
    visible: 'Sichtbar für Kunde',
    hidden: 'Nur im Admin Tool sichtbar',
    child: 'Kind',
    adult: 'Erwachsener',
    teen: 'Jugendlicher',
    PERCENTAGE5: '5%',
    PERCENTAGE20: '20%',
    SKIPASS_ZERMATT: 'Skipass Zermatt',
    SKIPASS_INTERNATIONAL: 'Skipass International (Zermatt-Cervinia)',
    SKIPASS_ZERMATT_SHUTTLE: 'Skipass Zermatt mit Shuttle',
    SKIPASS_INTERNATIONAL_SHUTTLE:
      'Skipass International (Zermatt-Cervinia) mit Shuttle',
    SKIPASS_SUMMER: 'Ski Pass Sommer',
    SKIPASS_INTERNATIONAL_SUMMER: 'Skipass Sommer',
    SINGLERIDE_ZERMATT_FURI: 'Zermatt Furi Einfache',
    RETOURRIDE_ZERMATT_FURI: 'Zermatt Furi Retour',
    SINGLERIDE_ZERMATT_SCHWARZSEE: 'Zermatt Schwarzsee Einfach',
    RETOURRIDE_ZERMATT_SCHWARZSEE: 'Zermatt Schwarzsee Retour',
    SINGLERIDE_ZERMATT_TROCKENER_STEG: 'Zermatt Trockener Steg Einfach',
    RETOURRIDE_ZERMATT_TROCKENER_STEG: 'Zermatt Trockener Steg Retour',
    RETOURRIDE_ZERMATT_GLACIER_PARADISE:
      'Zermatt Matterhorn Glacier Paradise Retour',
    ENTRY_GLACIER_PALAST: 'Gletscherpalast Eintritt',
    SINGLERIDE_ZERMATT_SUNNEGGA: 'Zermatt Sunnegga Einfach',
    RETOURRIDE_ZERMATT_SUNNEGGA: 'Zermatt Sunnegga Retour',
    SINGLERIDE_ZERMATT_BLAUHERD: 'Zermatt Blauherd Einfach',
    RETOURRIDE_ZERMATT_BLAUHERD: 'Zermatt Blauherd Retour',
    SINGLERIDE_ZERMATT_ROTHORN: 'Zermatt Rothorn Einfach',
    RETOURRIDE_ZERMATT_ROTHORN: 'Zermatt Rothorn Retour',
    COMBITICKET_GLACIER_TRAIL: 'Kombi-Ticket Glacier Trail',
    COMBITICKET_5_SEENWEG_BLUMENWEG: 'Kombi-Ticket 5 Seenweg Blumenweg',
    RETOURRIDE_ZERMATT_GORNERGRAT: 'Zermatt Gornergrat Retour',
    ROUNDTOUR_ZERMATT_GORNERGRAT: 'Zermatt Gornergrat Rundfahrt',
    PEAK_TO_PEAK: 'Peak 2 Peak',
    PEAKPASS_ZERMATT: 'Peak Pass',
    COMBITICKET_NATURWEG_BLAUHERD_RIFFELALP: 'Naturweg',
    COMBITICKET_NATURWEG_SUNNEGGA_RIFFELALP:
      'Kombi-Ticket Naturweg Sunnegga-Riffelalp',
    BIKE_PASS_ZERMATT: 'Bike Pass Zermatt',
    BIKE_DAY_PASS_SUNEGGA: 'Bike Pass Sunnegga',
    BIKE_DAY_PASS_SUNEGGA_SCHWARZSEE: 'Bike Pass light',
    SKIPASS_BEGINNER: 'Beginner-Skipass',
    HALFDAY: '0.5',
    ONE: '1',
    TWO: '2',
    THREE: '3',
    FOUR: '4',
    FIVE: '5',
    SIX: '6',
    SEVEN: '7',
    EIGHT: '8',
    NINE: '9',
    TEN: '10',
    ELEVEN: '11',
    TWELVE: '12',
    THIRTEEN: '13',
    FOURTEEN: '14',
    FIFTEEN: '15',
    SIXTEEN: '16',
    SEVENTEEN: '17',
    EIGHTEEN: '18',
    NINETEEN: '19',
    TWENTY: '20',
    TWENTYONE: '21',
    TWO_OF_FOUR: '2-4',
    THREE_OF_FIVE: '3-5',
    FOUR_OF_SIX: '4-6',
    FIVE_OF_SEVEN: '5-7',
    SIX_OF_EIGHT: '6-8',
    SKICARE_ZERMATT: 'Skicare Zermatt',
    PASSPROTECT_ZERMATT: 'Passprotect Zermatt',
    SKICARE_INTERNATIONAL: 'Skicare International',
    PASSPROTECT_INTERNATIONAL: 'Passprotect International',
    CREATED: 'Erstellt',
    PENDING: 'H\u00e4ngig',
    IN_PROGRESS: 'In Bearbeitung',
    OK: 'OK',
    SUCCESS: 'Erfolgreich',
    FAILURE: 'Fehler',
    DECLINED: 'Abgelehnt',
    ABORTED: 'Abgebrochen',
    EXPIRED: 'Abgelaufen',
    DEBIT: 'Abbuchung',
    REFUND: 'R\u00fcckerstattung',
    PREAUTH: 'Authorisiert',
    CAPTURE: 'Abbuchung',
    CANCEL: 'Authorisierung - Abbruch',
    ISSUED: 'Erstellt',
    PROCESSING: 'In Bearbeitung',
    CANCELLED: 'Storniert',
    ticketStatus: {
      PENDING: 'Übermittelt',
      RESERVED: 'Fertig',
      BOOKED: 'Fertig',
      BOOKED_AND_TRANSFERRED: 'Fertig',
      BOOKED_AND_REJECTED: 'Fehler',
      CANCELED: 'Storniert',
      CANCELED_AND_TRANSFERRED: 'Storniert',
      CANCELED_AND_REJECTED: 'Storniert',
      CORRECTED: 'Fertig',
      NO_STATUS: 'Übermittelt',
      NOT_PAID: 'Übermittelt',
      PAID: 'Fertig',
      REFUNDED: 'Storniert',
      REFUND_AND_TRANSFERRED: 'Storniert',
      REFUND_AND_REJECTED: 'Storniert',
    },
    permissionState: {
      ISSUED: 'Erstellt',
      DELIVERED: '\u00dcbertragen',
      PRODUCED: 'Produziert',
      CONSUMED: 'Benutzt',
      BLOCKED: 'Blockiert',
      RENEWED: 'Erneuert',
      EXPIRED: 'Abgeloffen',
    },
    SKIDATA_ADMIN_READ: 'Skidata lesen',
    SKIDATA_ADMIN_WRITE: 'Skidata modifizieren',
    SKIDATA_ADMIN_REPORT: 'Skidata Report generieren',
    SKIDATA_SYNC_PRICES: 'Skidata Preise synchronisieren',
    BLS_ADMIN_READ: 'Bls lesen',
    BLS_ADMIN_REPORT: 'Bls Report generieren',
    TENANT_ADMIN_WRITE: 'Mandanten verwalten',
    ZBAG_ADMIN_LIVE_FEED: 'ZBAG live feed upload',
    ADMIN: 'Admin',
    SUPER_ADMIN: 'Super Admin',
    MGB_ADMIN_REPORT: 'MGB Report generieren',
    MGB_ADMIN_READ: 'Mgb lesen',
    MGB_ADMIN_WRITE: 'MGB modifizieren',
    ZBAG: 'Zermatt Bergbahnen AG',
    BONFIRE: 'Bonfire AG',
    MGB_GGB: 'MGB/GGB',
    ticketType: {
      SKIPASS_ZERMATT: 'Skipass Zermatt',
      SKIPASS_INTERNATIONAL: 'Skipass International',
      SKIPASS_ZERMATT_SHUTTLE: 'Skipass Zermatt Shuttle',
      SKIPASS_INTERNATIONAL_SHUTTLE: 'Skipass International Shuttle',
      SKIPASS_SUMMER: 'Skipass Sommer (old)',
      SKIPASS_INTERNATIONAL_SUMMER: 'Skipass Sommer',
      SINGLERIDE_ZERMATT_FURI: 'Zermatt Furi Einfache',
      RETOURRIDE_ZERMATT_FURI: 'Zermatt Furi Retour',
      SINGLERIDE_ZERMATT_SCHWARZSEE: 'Zermatt Schwarzsee Einfach',
      RETOURRIDE_ZERMATT_SCHWARZSEE: 'Zermatt Schwarzsee Retour',
      SINGLERIDE_ZERMATT_TROCKENER_STEG: 'Zermatt Trockener Steg Einfach',
      RETOURRIDE_ZERMATT_TROCKENER_STEG: 'Zermatt Trockener Steg Retour',
      RETOURRIDE_ZERMATT_GLACIER_PARADISE:
        'Zermatt Matterhorn Glacier Paradise Retour',
      ENTRY_GLACIER_PALAST: 'Gletscherpalast Eintritt',
      SINGLERIDE_ZERMATT_SUNNEGGA: 'Zermatt Sunnegga Einfach',
      RETOURRIDE_ZERMATT_SUNNEGGA: 'Zermatt Sunnegga Retour',
      SINGLERIDE_ZERMATT_BLAUHERD: 'Zermatt Blauherd Einfach',
      RETOURRIDE_ZERMATT_BLAUHERD: 'Zermatt Blauherd Retour',
      SINGLERIDE_ZERMATT_ROTHORN: 'Zermatt Rothorn Einfach',
      RETOURRIDE_ZERMATT_ROTHORN: 'Zermatt Rothorn Retour',
      COMBITICKET_GLACIER_TRAIL: 'Kombi-Ticket Glacier Trail',
      COMBITICKET_5_SEENWEG_BLUMENWEG: 'Kombi-Ticket 5 Seenweg Blumenweg',
      RETOURRIDE_ZERMATT_GORNERGRAT: 'Zermatt Gornergrat Retour',
      ROUNDTOUR_ZERMATT_GORNERGRAT: 'Zermatt Gornergrat Rundfahrt',
      PEAK_TO_PEAK: 'Peak 2 Peak',
      PEAKPASS_ZERMATT: 'Peak Pass',
      COMBITICKET_NATURWEG_BLAUHERD_RIFFELALP: 'Naturweg',
      COMBITICKET_NATURWEG_SUNNEGGA_RIFFELALP:
        'Kombi-Ticket Naturweg Sunnegga-Riffelalp',
      BIKE_PASS_ZERMATT: 'Bike Pass Zermatt',
      BIKE_DAY_PASS_SUNEGGA: 'Bike Pass Sunnegga',
      BIKE_DAY_PASS_SUNEGGA_SCHWARZSEE: 'Bike Pass light',
      SINGLERIDE_ZERMATT_GORNERGRAT: 'Zermatt Gornergrat Einfachefahrt',
      SINGLERIDE_GORNERGRAT_ZERMATT: 'Gornergrat Zermatt Einfachefahrt',
      SINGLERIDE_ZERMATT_RIFFELALP: 'Zermatt Riffelalp Einfachefahrt',
      SINGLERIDE_RIFFELALP_ZERMATT: 'Riffelalp Zermatt Einfachefahrt',
      RETOURRIDE_ZERMATT_RIFFELALP: 'Zermatt Riffelalp Einfachefahrt',
      SINGLERIDE_ZERMATT_RIFFELBERG: 'Zermatt Riffelberg Einfachefahrt',
      SINGLERIDE_RIFFELBERG_ZERMATT: 'Zermatt Riffelberg Einfachefahrt',
      RETOURRIDE_ZERMATT_RIFFELBERG: 'Zermatt Riffelberg Einfachefahrt',
      SINGLERIDE_ZERMATT_ROTENBODEN: 'Zermatt Rotenboden Einfachefahrt',
      SINGLERIDE_ROTENBODEN_ZERMATT: 'Rotenboden Zermatt Einfachefahrt',
      RETOURRIDE_ZERMATT_ROTENBODEN: 'Zermatt Rotenboden Retourfahrt',
      SINGLERIDE_GORNERGRAT_AFTERNOON: 'Zermatt Gornergrat Einfachefahrt',
      SINGLERIDE_TAESCH_GORNERGRAT: 'Täsch Gornergrat Einfachefahrt',
      RETOURRIDE_TAESCH_GORNERGRAT: 'Täsch Gornergrat Retourfahrt',
      SINGLERIDE_TAESCH_ZERMATT: 'Täsch Zermatt Einfachefahrt',
      RETOURRIDE_TAESCH_ZERMATT: 'Zermatt Täsch Retourfahrt',
      SINGLERIDE_ZERMATT_TAESCH: 'Zermatt Täsch Einfachefahrt',
      SINGLERIDE_GORNERGRAT_GOURMETTICKET: 'Gornergrat-Gourmetticket',
      SKIPASS_BEGINNER: 'Beginner-Skipass',
    },
    shop: {
      SHOP: 'Shop',
      TRUE: 'wahr',
      FALSE: 'falsch',
      CATEGORY: 'Kategorie',
      ITEMS: 'Tickets',
      ITEM: 'Ticket',
      VALIDITIES: 'Verfügbarkeit',
      SAVE: 'Speichern',
      ADD_ITEMVALIDITY: 'Artikelverfügbarkeit hinzufügen',
      NEW_ITEMVALIDITY: 'Neue Artikelverfügbarkeit',
      BACK: 'Zurück',
      categoryTable: {
        ACTIONS: 'Actions',
        ID: 'Id',
        TITLE: 'Titel',
        DESCRIPTION: 'Beschreibung',
        ENABLED: 'Aktiviert',
        TYPE: 'Typ',
        POSITION: 'Position',
      },
      itemTable: {
        ACTIONS: 'Actions',
        ID: 'Id',
        TYPE: 'Typ',
        ENABLED: 'Aktiviert',
        POSITION: 'Position',
        VENDOR: 'Verkäufer',
      },
      itemValidityTable: {
        WARNING_TITLE_STARTDATE_MISSING_FIELD:
          'Please insert title and start date item validity',
        ACTIONS: 'Actions',
        ID: 'Id',
        START_DATE: 'Start Date',
        END_DATE: 'End Date',
        TITLE: 'Title',
        SELECTABLE_START_DATE: 'Selectable Start Date',
        SELECTABLE_END_DATE: 'Selectable End Date',
      },
      OPERATION_SUCCESS: 'Operation execute with success',
    },
    pricingStrategy: {
      FULL_PRICE: 'Full Price',
      FULL_PRICE_FREE_KIDS_SATURDAY: ' Full Price Free Kids Saturday',
      PREORDER: 'Pre-order',
      PREORDER_FREE_KIDS_SATURDAY: 'Pre-order Free Kids Saturday',
      PRESALE: 'Pre-sale',
      PRESALE_FREE_KIDS_SATURDAY: 'Pre-sale Free Kids Saturday',
    },
    PICKUP_TICKET_FEE: 'Pickup-Gebühr',
    productType: {
      SKIPASS_WINTER: 'Skipass Winter',
      FLEXPASS_WINTER: 'Flexpass Winter',
      SKIPASS_SUMMER: 'Skipass Sommer',
      PEAK_PASS: 'Peak Pass',
      ZERMATT_FURI: 'Zermatt-Furi',
      ZERMATT_SCHWARZSEE: 'Zermatt-Schwarzsee',
      ZERMATT_ROTHORN: 'Zermatt-Rothorn',
      ZERMATT_TROCKENER_STEG: 'Zermatt-Trockener Steg',
      ZERMATT_MATTERHORN_GLACIER_PARADISE:
        'Zermatt-Matterhorn glacier paradise',
      ZERMATT_SUNNEGGA: 'Zermatt-Sunnegga',
      ZERMATT_BLAUHERD: 'Zermatt-Blauherd',
      PEAK_TO_PEAK: 'Peak2Peak Ticket',
      GORNERGRAT_ROUNDTRIP: 'Gornergrat-Rundfahrt',
      COMBITICKET_GLACIER_TRAIL: 'Matterhorn Glacier Trail',
      COMBITICKET_5_SEENWEG_BLUMENWEG: '5-Seenweg / Blumenweg',
      NATURWEG: 'Naturweg',
      BIKE_PASS_ZERMATT: 'Bikepass Zermatt',
      BIKE_DAY_PASS_SUNNEGGA: 'Bike Tageskarte Sunnegga',
      BIKE_DAY_PASS_SUNNEGGA_SCHWARZSEE: 'Bike Pass light',
      ZERMATT_GORNERGRAT: 'Zermatt–Gornergrat',
      GORNERGRAT_ZERMATT: 'Gornergrat-Zermatt',
      TASCH_GORNERGRAT: 'Täsch–Gornergrat',
      GORNERGRAT_GOURMETTICKET: 'Gornergrat-Gourmetticket',
      ZERMATT_ROTENBODEN: 'Zermatt–Rotenboden',
      ROTENBODEN_ZERMATT: 'Rotenboden-Zermatt',
      ZERMATT_RIFFELALP: 'Zermatt–Riffelalp',
      RIFFELALP_ZERMATT: 'Riffelalp-Zermat',
      ZERMATT_RIFFELBERG: 'Zermatt–Riffelberg',
      RIFFELBERG_ZERMATT: 'Riffelberg-Zermatt',
      GORNERGRAT_AFTERNOON: 'Gornergrat-Nachmittag',
      ZERMATT_TASCH: 'Shuttle Zermatt-Täsch',
      TASCH_ZERMATT: 'Shuttle Täsch–Zermat',
      SKIPASS_BEGINNER: 'Beginner-Skipass',
    },
    pools: {
      ZERMATT: 'Zermatt',
      INTERNATIONAL: 'International',
      MATTERHORN_GLACIER_PARADISE: 'Matterhorn glacier paradise',
      SUNNEGGA_ROTHORN: 'Sunnegga-Rothorn',
      MGB_GGB: 'MGB/GGB',
      INTERNATIONAL_SUMMER: 'International summer',
      INTERNATIONAL_WINTER: 'International winter',
    },
    personTypes: {
      adult: 'adult',
      teen: 'teen',
      child: 'child',
    },
    paymentTypes: {
      VISA: 'VISA',
      AMEX: 'AMEX',
      Mastercard: 'Mastercard',
    },
    ticketLoadings: {
      SWISSPASS: 'SWISSPASS',
      ZERMATT_CARD: 'ZERMATT-CARD',
      SKIDATA: 'SKIDATA',
      RFID: 'QR PICK-UP',
      BARCODE: 'QR TICKET',
    },
    app: {
      FILE: 'Datei',
      FILES: 'Aktuelles Dashboard Bild',
      SAVE: 'Speichern',
      OPERATION_SUCCESS: 'Erfolgreich durchgeführt',
      FILENAME: 'Dateiname',
      MIMETYPE: 'Typ',
      NEW_FILE: 'Neues Dashboard Bild',
      INPUT_FILE_LABEL: 'Max 900kb, Ratio: 4:3',
      IPHONE_MODEL: 'iPhone 8 - iOS 13.1',
      SELECT_FILE_WANING_MESSAGE: 'Bitte wähle eine Datei zum Hochladen aus',
      SELECT_CORRECT_FILE_WANING_MESSAGE:
        'Die ausgewählte Datei ist kein gültiger Datei-Typ. Bitte wähle ein jpg oder png.',
      FILE_TOO_LARGE:
        'Die ausgewählte Datei ist z ugross. Bitte wähle eine Datei mit weniger als 5Mb',
    },
    user: {
      newsletter: 'Newsletter',
      gender: 'Gender',
      country: 'Country',
      MALE: 'Male',
      FEMALE: 'Female',
      OTHER: 'Other',
    },
    voucherPayment: 'Voucher Redeem',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/localization.js